var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { calculateRouteMileage as calcRouteMileage } from './route-calculator';
import { STATIONS_1520, STATIONS_1435 } from './constants';
// Funkcija stočių sąrašui gauti iš API
export function fetchStations(gauge) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`/wp-json/ltg/v1/stations?gauge=${gauge}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = yield response.json();
            return data.stations || [];
        }
        catch (error) {
            console.error('Error fetching stations:', error);
            return gauge === '1435' ? STATIONS_1435 : STATIONS_1520;
        }
    });
}
// Įkelti ltg_routes.js failą dinamiškai
export function loadRouteData() {
    return __awaiter(this, void 0, void 0, function* () {
        if (typeof window !== 'undefined' && window.ltgRoutesData) {
            return window.ltgRoutesData;
        }
        return new Promise((resolve, reject) => {
            const existingScript = document.querySelector('script[data-ltg-routes]');
            if (existingScript) {
                const checkInterval = setInterval(() => {
                    if (window.ltgRoutesData) {
                        clearInterval(checkInterval);
                        resolve(window.ltgRoutesData);
                    }
                }, 100);
                setTimeout(() => {
                    clearInterval(checkInterval);
                    reject(new Error('Timeout loading route data'));
                }, 10000);
                return;
            }
            const script = document.createElement('script');
            script.src = '/wp-content/themes/gelezinkeliai/plugins/elementor/widgets/route-length-calculator/ltg_routes.js';
            script.setAttribute('data-ltg-routes', 'true');
            script.async = true;
            script.onload = () => {
                const checkInterval = setInterval(() => {
                    if (window.ltgRoutesData) {
                        clearInterval(checkInterval);
                        resolve(window.ltgRoutesData);
                    }
                }, 100);
                setTimeout(() => {
                    clearInterval(checkInterval);
                    reject(new Error('Timeout loading route data'));
                }, 10000);
            };
            script.onerror = () => {
                reject(new Error('Failed to load ltg_routes.js'));
            };
            document.head.appendChild(script);
        });
    });
}
// Maršruto ridos skaičiavimo funkcija
export function calculateRouteMileage(fromStation, toStation, viaStation, gauge, routeData) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!routeData) {
            return { mileage: null, path: null, cache: null };
        }
        try {
            return yield calcRouteMileage(fromStation, toStation, viaStation, gauge, routeData);
        }
        catch (error) {
            console.error('Route calculation error:', error);
            return { mileage: null, path: null, cache: null };
        }
    });
}
